// extracted by mini-css-extract-plugin
export default {"backdrop":"XlsxOrCsvDialog_backdrop__S5qCd","loader":"XlsxOrCsvDialog_loader__FVG1Z","spin":"XlsxOrCsvDialog_spin__eNX69"};